import { render, staticRenderFns } from "./DistributionUser.vue?vue&type=template&id=02d2d2c2&scoped=true&"
import script from "./DistributionUser.vue?vue&type=script&lang=js&"
export * from "./DistributionUser.vue?vue&type=script&lang=js&"
import style0 from "./DistributionUser.vue?vue&type=style&index=0&id=02d2d2c2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d2d2c2",
  null
  
)

export default component.exports